module.exports = __webpack_public_path__ + "img/invitation-icon.29d48674.svg";